<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年05月12日 15:24:09 +0800
 * @最后修改时间: 2021-11-17 16:41:24
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Shift\ShiftList\components\newGroupMapping.vue
 -->
<template>
  <normalDialog
    width="680"
    maxWidth="680"
    @close="closePorpertyDialog"
    :title="$t('label_essweb_shift_form_dialog_newSiteTitle')"
    :dialog="show"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              isRequired
              label="label_essweb_shift_form_siteNameLabel"
              :items="SiteList"
              v-model="curSiteuuid"
              :rules="$GetRules(['_Require_Rules'], [null])"
              item-text="site_name"
              item-value="uuid"
            >
            </AutoComplete>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions newBtn @new="newProperty" @cancel="closePorpertyDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newGroupMapping",
  props: ["show"],
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
    curSite() {
      if (this.curSiteuuid) {
        return this.SiteListData.filter(
          (ele) => ele.uuid === this.curSiteuuid
        )[0];
      } else {
        return null;
      }
    },
    SiteList() {
      return this.$getSelectTrans(this.SiteListData, "site_name");
    },
  },
  data() {
    return {
      curSiteuuid: null,
      SiteListData: [],
    };
  },
  watch: {
    show(val) {
      if (!val) {
        if (this.$refs["form"]) this.$refs["form"].reset();
      }
    },
  },
  mounted() {
    this.getSiteList();
  },
  methods: {
    getSiteList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_site",
        url: "/site/get-site-list/",
        data: {},
      }).then((res) => {
        that.SiteListData = res.data;
      });
    },
    closePorpertyDialog: function () {
      this.$emit("close", false);
    },
    newProperty: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("new", this.curSite);
    },
  },
};
</script>
